import { useEffect } from 'react';

const SUFFIX = 'Regta';

/**
 * Set the document title (and restore on unmount). Pass `null` to skip
 * — useful while data is still loading and a dynamic title would
 * otherwise flash a placeholder into the browser back-button history.
 */
export function usePageTitle(title: string | null): void {
  useEffect(() => {
    if (title === null) return;
    const prev = document.title;
    document.title = title ? `${title} · ${SUFFIX}` : SUFFIX;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
